const areas = {
  headerButtons: {
    create: {
      createBtn: 'Crear',
    },

    import: 'Importar',
  },
  table: {
    headers: {
      name: 'Name',
      type: 'Type',
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  toast: {
    error: {
      badResponse: '[zona] respuesta incorrecta del servidor',
      create: {},
      edit: {},
      delete: '[zona] No se pudo eliminar',
    },
    success: {
      create: {
        default: 'Zona creada correctamente',
      },
      edit: {},
      delete: {
        default: 'Las zonas se eliminaron correctamente',
      },
    },
  },
  create: {
    createBtn: 'Nuevo',
    successToast: {
      message: '¡Éxito! zona creada',
    },
    errorToast: {
      message: '¡Ocurrió un error! No se pudo crear el zona',
      duplicateMessage: 'Ya existe un zona con el nombre elegido',
    },
    validations: {
      name: 'El nombre es obligatorio',
      type: 'El tipo es obligatorio',
      siteId: 'El ID de sitio es obligatorio',
    },
  },
  delete: {
    deleteBtn: 'Eliminar',
    deleteModal: {
      header: '¿Eliminar zonas?',
      body: 'Está a punto de eliminar {{number}} zonas',
    },
    successToast: {
      message: '¡Eliminado correctamente!',
    },
    errorToast: {
      message: '¡Ocurrió un error! No se pudo eliminar el zona',
    },
  },
  update: {
    successToast: {
      message: '¡Éxito! Actualizaciones de zona',
    },
    errorToast: {
      message: '¡Ocurrió un error! No se pudo actualizar el zona',
    },
    validations: {
      name: 'El nombre es obligatorio',
      type: 'El tipo es obligatorio',
    },
  },
  forms: {
    tabs: {
      general: 'General',
      advancedSettings: 'Configuración avanzada',
    },

    header: {
      createArea: {
        title: 'Crear',
      },

      updateArea: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Detalles',
        fields: {
          showOtherAreas: 'Mostrar otras zonas',
          name: 'Nombre',
          type: 'Tipo',
        },
      },
      map: {
        header: 'Mapa',
      },
      settings: {
        btnAdd: 'Añadir',
        header: 'Ratio',
        label: 'Elejir Ratio de Area',
        notice: 'Las proporciones que contienen \'Todos\' están asociadas y se pueden editar en todas las zonas.',
        headerAreaRestrictions: 'Restricciones de zona',
        titleAreaRestrictions: 'Bloquear acciones',
      },
      advancedSettings: {
        consistentPassengerRouting: {
          title: 'Enrutamiento Consistente de Pasajeros',
          toolTipInformation:
            'Garantiza que el mismo grupo de pasajeros siga siempre la misma ruta hacia y desde la zona, optimizando la eficiencia del viaje y minimizando la confusión.',
        },
        sameDriverForGroup: {
          title: 'Mismo Conductor para el Grupo',
          toolTipInformation:
            'Asigna el mismo conductor para transportar al grupo de pasajeros tanto en la recogida como en la entrega, proporcionando familiaridad y consistencia.',
        },
        overrideOptions: {
          bySystemSettings: 'Según la Configuración del Sistema',
          enabled: 'Habilitado',
          disabled: 'Deshabilitado',
        },
        tripBoardingTime: {
          title: 'Tiempo de abordaje',
          toolTipInformation:
            'El tiempo que se tarda en recoger a un pasajero en su parada (este parámetro afectará la duración total del viaje)',
        },
        waitForBoardingTime: {
          title: 'Tiempo de espera para abordaje',
          toolTipInformation: 'Al llegar a una parada, el conductor esperará hasta la hora exacta de recogida si es necesario.',
        },
        tripDropOffTime: {
          title: 'Tiempo de descenso',
          toolTipInformation:
            'El tiempo que se tarda en dejar a un pasajero en su parada (este parámetro afectará la duración total del viaje)',
        },
        maxDropOffEarly: {
          title: 'Máx. adelanto en descenso',
          toolTipInformation:
            'Número máximo de minutos que un conductor puede llegar antes con respecto a la hora de descenso establecida en la reserva',
        },
        maxDropOffDelay: {
          title: 'Máx. retraso en descenso',
          toolTipInformation:
            'Número máximo de minutos que un conductor puede llegar tarde con respecto a la hora de descenso establecida en la reserva',
        },
        maxBoardingDelay: {
          title: 'Máx. retraso en abordaje',
          toolTipInformation:
            'Número máximo de minutos que un conductor puede llegar tarde con respecto a la hora de recogida establecida en la reserva',
        },
        maxBoardingEarly: {
          title: 'Máx. adelanto en abordaje',
          toolTipInformation:
            'Número máximo de minutos que un conductor puede llegar antes con respecto a la hora de recogida establecida en la reserva',
        },
        maxTripDuration: {
          title: 'Máx. duración del viaje',
          toolTipInformation: 'Duración máxima de un viaje en minutos',
        },
        maxSinglePassengerTime: {
          title: 'Máx. duración del viaje por pasajero',
          toolTipInformation: 'Duración máxima de un viaje en minutos por pasajero',
        },
      },
    },
  },

  polygoneTypes: {
    operationalArea: 'Zona Operacional',
    fares: 'Tarifas',
    routes: 'Rutas',
    block: 'Bloqueo',
  },
};

export default areas;
